"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arzachena": {
    "ba00b574": [{
      "hkey": "58b0bf07",
      "slug": "cannigione-laconia",
      "name": "Cannigione-Laconia",
      "primary": true,
      "skipSearch": false
    }],
    "cannigione": [{
      "hkey": "58b0bf07",
      "slug": "cannigione-laconia",
      "name": "Cannigione-Laconia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "76e42e5b": [{
      "hkey": "83ac7380",
      "slug": "arzachena",
      "name": "Arzachena",
      "primary": true,
      "skipSearch": false
    }],
    "farina": [{
      "hkey": "83ac7380",
      "slug": "arzachena",
      "name": "Arzachena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e09a733": [{
      "hkey": "58b0bf07",
      "slug": "cannigione-laconia",
      "name": "Cannigione-Laconia",
      "primary": true,
      "skipSearch": false
    }],
    "laconia": [{
      "hkey": "58b0bf07",
      "slug": "cannigione-laconia",
      "name": "Cannigione-Laconia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arzachena"
    }],
    "ba05a320": [{
      "hkey": "e2b7f30d",
      "slug": "capo-ferro",
      "name": "Capo Ferro",
      "primary": true,
      "skipSearch": false
    }],
    "porto-cervo-cala-del-faro": [{
      "hkey": "e2b7f30d",
      "slug": "capo-ferro",
      "name": "Capo Ferro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1f0da9ae": [{
      "hkey": "04a66c94",
      "slug": "capriccioli",
      "name": "Capriccioli",
      "primary": true,
      "skipSearch": false
    }],
    "porto-cervo-capriccioli": [{
      "hkey": "04a66c94",
      "slug": "capriccioli",
      "name": "Capriccioli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c7e891e0": [{
      "hkey": "e638f850",
      "slug": "porto-cervo",
      "name": "Porto Cervo",
      "primary": true,
      "skipSearch": false
    }],
    "porto-cervo-marina": [{
      "hkey": "e638f850",
      "slug": "porto-cervo",
      "name": "Porto Cervo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "arzachena"
    }],
    "7522d403": [{
      "hkey": "35d0c277",
      "slug": "pantogia",
      "name": "Pantogia",
      "primary": true,
      "skipSearch": false
    }],
    "porto-cervo-pantogia": [{
      "hkey": "35d0c277",
      "slug": "pantogia",
      "name": "Pantogia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1c01e2a9": [{
      "hkey": "a829a527",
      "slug": "romazzino",
      "name": "Romazzino",
      "primary": true,
      "skipSearch": false
    }],
    "porto-cervo-romazzino": [{
      "hkey": "a829a527",
      "slug": "romazzino",
      "name": "Romazzino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;